export interface CreatePlanRulesTemplateRequest {
  planId?: string;
  targetJobDuration: string; 
  vehicleProfile: string;
  serviceTime: number; 
  startLocationLatitude?: number;
  startLocationLongitude?: number;
  endLocationLatitude?: number;
  endLocationLongitude?: number;
  serviceFrequency: number;
  targetSegmantDuration?: string; 
  microSegmantSize?: number;
  speedOverride?: number;
  includeSnapIn: boolean;
  snapInSpeed?: number;
  snapInDistance?: number;
  connectionId: string;
  exportPlanToAMS: boolean;
  description?: string;
  startLocationAddress?: string;
  endLocationAddress?: string;
}
